/* One atomic cart update replaces a single XL box with the existing bundle. */
(() => {
  let pending = false;
  const selector = '[data-ww-bundle-switch]';
  const reveal = () => document.querySelectorAll(selector).forEach(button => { button.hidden = false; });
  // Use the freshly rendered Liquid subtotal as the shared source of truth.
  // It includes discounts and excludes delivery, including after checkout returns.
  const syncTotals = estimate => {
    const region = estimate.closest('[data-cart-message-container]');
    if (!region) return;
    const total = Number(estimate.dataset.wwItemsTotal);
    const threshold = Number(estimate.dataset.wwThreshold);
    const finalPrice = region.querySelector('[data-cart-final]');
    if (finalPrice) finalPrice.textContent = estimate.dataset.wwItemsMoney;
    region.querySelectorAll('[data-cart-message]').forEach(message => {
      message.classList.toggle('is-success', total >= threshold && total > 0);
      message.querySelectorAll('[data-left-to-spend]').forEach(left => { left.textContent = estimate.dataset.wwLeftMoney; });
      message.querySelectorAll('[data-cart-progress]').forEach(progress => {
        const percent = Math.min(100, Math.max(0, total / threshold * 100));
        progress.style.strokeDashoffset = 28 * Math.PI * (1 - percent / 200);
      });
    });
  };
  reveal();
  document.querySelectorAll('.ww-cart-estimate').forEach(syncTotals);
  const observer = new MutationObserver(records => {
    reveal();
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.matches('.ww-cart-estimate')) syncTotals(node);
      else node.querySelectorAll('.ww-cart-estimate').forEach(syncTotals);
    }));
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Checkout can change discounts while this page is in the back/forward cache.
  // Refresh through the theme's existing cart renderer without changing the cart.
  window.addEventListener('pageshow', async event => {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (!event.persisted && navigation?.type !== 'back_forward') return;
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js', {
        credentials: 'same-origin', cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    } catch {
      // Keep the current cart available if the read fails; never retry a write.
    }
  });

  document.addEventListener('click', async event => {
    const button = event.target.closest(selector);
    if (!button || pending) return;
    event.preventDefault();
    const box = button.closest('.ww-cart-bundle');
    const error = box.querySelector('.ww-cart-bundle__error');
    const label = button.textContent;
    const cartUrl = button.dataset.cartUrl;
    const root = window.Shopify.routes.root;
    const cartRegion = button.closest('[data-cart-message-container]');
    const controls = [...cartRegion.querySelectorAll('button, input, select, textarea')].map(control => [control, control.disabled]);
    const wasInert = cartRegion.inert;
    cartRegion.inert = true;
    controls.forEach(([control]) => { control.disabled = true; });
    pending = true;
    button.disabled = true;
    button.textContent = button.dataset.busyText;
    error.hidden = true;
    box.setAttribute('aria-busy', 'true');
    let submitted = false;

    try {
      const responses = await Promise.all([
        fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }),
        fetch(button.dataset.bundleUrl + '.js', { credentials: 'same-origin', cache: 'no-store' })
      ]);
      if (responses.some(response => !response.ok)) throw new Error('read');
      const [cart, product] = await Promise.all(responses.map(response => response.json()));
      const item = cart.items[0];
      const variant = product.variants.find(variant => String(variant.id) === button.dataset.bundleId);
      const eligible = cart.currency === 'AED' && cart.items.length === 1 && cart.item_count === 1 && cart.total_discount === 0 &&
        String(item.product_id) === button.dataset.xlProductId && !item.selling_plan_allocation && Object.keys(item.properties || {}).length === 0 &&
        variant && variant.available && variant.price === Number(button.dataset.bundlePrice);
      if (!eligible) {
        error.textContent = button.dataset.changedText;
        error.hidden = false;
        return;
      }
      const updates = { [item.key]: 0, [button.dataset.bundleId]: 1 };
      submitted = true;
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error('update');
      await response.json();
      window.location.assign(cartUrl);
    } catch {
      error.textContent = button.dataset.errorText;
      error.hidden = false;
      // An uncertain write is never automatically retried. Review the actual cart.
      if (submitted) {
        const review = document.createElement('a');
        review.href = cartUrl;
        review.textContent = button.dataset.reviewText;
        review.className = 'ww-cart-bundle__details';
        error.append(document.createElement('br'), review);
      }
    } finally {
      box.removeAttribute('aria-busy');
      cartRegion.inert = wasInert;
      controls.forEach(([control, disabled]) => { if (control !== button) control.disabled = disabled; });
      if (!submitted) {
        pending = false;
        button.disabled = false;
        button.textContent = label;
      }
    }
  });
})();
